import axios from "axios";
import configData from ".././config.json"

export const getAPISocietyFilter = async() => {
    try{
        const Society = await  axios.get(configData.API_URL + `/filter/society`)
        return Society;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }
     
  };


export const getAPIAreaFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const Area = await  axios.get(configData.API_URL + `/filter/area?companyKeyListStr=${societyFilterSelected}`)
        return Area;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};


export const getAPIDistrictFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const District = await  axios.get(configData.API_URL + `/filter/district?companyKeyListStr=${societyFilterSelected}`)
        return District;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};


export const getAPIAgentFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const Agent = await  axios.get(configData.API_URL + `/filter/agent?companyKeyListStr=${societyFilterSelected}`)
        return Agent;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};


export const getAPIChannelFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const Channel = await  axios.get(configData.API_URL + `/filter/channel?companyKeyListStr=${societyFilterSelected}`)
        return Channel;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};


export const getAPICategoryFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const Category = await  axios.get(configData.API_URL + `/filter/category?companyKeyListStr=${societyFilterSelected}`)
        return Category;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};


export const getAPISubCategoryFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const SubCategory = await  axios.get(configData.API_URL + `/filter/sub_category?companyKeyListStr=${societyFilterSelected}`)
        return SubCategory;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};


export const getAPICentralFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const Central = await  axios.get(configData.API_URL + `/filter/central?companyKeyListStr=${societyFilterSelected}`)
        return Central;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};


export const getAPISuperCentralFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const Central = await  axios.get(configData.API_URL + `/filter/super_central?companyKeyListStr=${societyFilterSelected}`)
        return Central;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};

export const getAPISignFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const Sign = await  axios.get(configData.API_URL + `/filter/sign?companyKeyListStr=${societyFilterSelected}`)
        return Sign;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};


export const getAPIGroupFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const Group = await  axios.get(configData.API_URL + `/filter/group?companyKeyListStr=${societyFilterSelected}`)
        return Group;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};
export const getAPITastingFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const tasting = await  axios.get(configData.API_URL + `/filter/tasting?companyKeyListStr=${societyFilterSelected}`)
        return tasting;
    }
    catch(err){
        console.error("Error - getTasting: " + err);
    }

};
export const getAPIPalladinoFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const palladino = await  axios.get(configData.API_URL + `/filter/palladino?companyKeyListStr=${societyFilterSelected}`)
        return palladino;
    }
    catch(err){
        console.error("Error - getPalladino: " + err);
    }
};
export const getAPIEventFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const event = await  axios.get(configData.API_URL + `/filter/event?companyKeyListStr=${societyFilterSelected}`)
        return event;
    }
    catch(err){
        console.error("Error - getEvent: " + err);
    }

};


export const getAPIRegionFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const Region = await  axios.get(configData.API_URL + `/filter/region?companyKeyListStr=${societyFilterSelected}`)
        return Region;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};


export const getAPIProvinceFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const Province = await  axios.get(configData.API_URL + `/filter/province?companyKeyListStr=${societyFilterSelected}`)
        return Province;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};


export const getAPILocalityFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const Locality = await  axios.get(configData.API_URL + `/filter/locality?companyKeyListStr=${societyFilterSelected}`)
        return Locality;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }

};


export const getAPIMacroFamilyFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const MacroFamily = await  axios.get(configData.API_URL + `/filter/macrofamily?companyKeyListStr=${societyFilterSelected}`)
        return MacroFamily;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }
};

export const getAPITradeCategoryFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const TradeCategory = await  axios.get(configData.API_URL + `/filter/trade_category?companyKeyListStr=${societyFilterSelected}`)
        return TradeCategory;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }
};

export const getAPIAccountingFamilyFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const accounting_family = await  axios.get(configData.API_URL + `/filter/accounting_family?companyKeyListStr=${societyFilterSelected}`)
        return accounting_family;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }
};


export const getAPICommercialFamilyFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const commercial_family = await  axios.get(configData.API_URL + `/filter/commercial_family?companyKeyListStr=${societyFilterSelected}`)
        return commercial_family;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }
};


export const getAPIProductFilter = async(societyFilterSelected : string | null) => {
    try{
        if(societyFilterSelected == null)
            societyFilterSelected = "";
        
        const product = await  axios.get(configData.API_URL + `/filter/product?companyKeyListStr=${societyFilterSelected}`)
        return product;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }
};

export const getAPISalesFilter = async() => {
    try{
        const sales = await  axios.get(configData.API_URL + "/filter/sales")
        return sales;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }
};

export const getAPIDistanceFilter = async() => {
    try{
        const distance = await  axios.get(configData.API_URL + "/filter/distance")
        return distance;
    }
    catch(err){
        console.error("Error - getTickets: " + err);
    }
};
